import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { SiteEditService } from '../../core/site-edit';
import { StagingApiService, StagingService } from '../../core/staging';
import { DebugSiteModule } from '../debug-site';
import { ManageStagingSiteComponent } from './cards/manage-staging-site/manage-staging-site.component';
import { StagingComponent } from './staging.component';

import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { StagingFromBackupModule } from '../staging-from-backup/staging-from-backup.module';
import { StagingFromTemplateModule } from '../staging-from-template/staging-from-template.module';
import { PushFinishedComponent } from './cards/push-finished/push-finished.component';
import { PushToLiveConfirmationComponent } from './cards/push-to-live-confirmation/push-to-live-confirmation.component';
import { PushToLiveComponent } from './cards/push-to-live/push-to-live.component';
import { ResetStagingComponent } from './cards/reset-staging/reset-staging.component';
import { StagingDescComponent } from './cards/staging-desc/staging-desc.component';

const routes: Routes = [
  {
    path: '',
    component: StagingComponent,
  },
];

@NgModule({
  imports: [
    MatMenuModule,
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    DebugSiteModule,
    MatCheckboxModule,
    MatIconModule,
    FormsModule,
    MatRadioModule,
    StagingFromBackupModule,
    StagingFromTemplateModule,
    GalaxyPageModule,
    ProductAnalyticsModule,
  ],
  declarations: [
    StagingComponent,
    ManageStagingSiteComponent,
    PushFinishedComponent,
    PushToLiveComponent,
    PushToLiveConfirmationComponent,
    ResetStagingComponent,
    StagingDescComponent,
  ],
  exports: [RouterModule],
  providers: [StagingService, SiteEditService, StagingApiService],
})
export class StagingModule {}
